var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view')],1),_c('v-footer',{attrs:{"padless":""}},[_c('v-col',{staticClass:"text-sm-center",attrs:{"cols":"12"}},[_vm._v(" เวอร์ชั่น "+_vm._s(_vm.version)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }